import React,{Component} from 'react';
import { connect } from 'react-redux';
// utils
import {
  loadIfStateAvailableInSessionStorage,
  savePageStateInSessionStorage,
  Translations,
  convertStringToArrayForRadio
} from '../../../../../utils';
// restClient
import {eapiClient, aemHostClient} from '../../../../../restClient';
// children
import DateSelector from '../../../../common/DateSelector/DateSelector';
import MultiLineSelect from '../../../../common/MultiLineSelect';
import Radiobutton from '../../../../common/Radio/radioButton';
import SingleLineSelect from '../../../../common/SingleLineSelect';
import PersistLink from '../../../../common/PersistLink';
//action Creator
import { setPersons } from '../../../actions/actionCreator';
//style
import './styles.css'

class PolandHsbcNetUserForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      methodFlag:false,
      //hsbcAdditionalUser:[],
      // polandChannelAdmins:[],
      echannelAdminData:[],
      dataReady: false,
      countryPolandForm :{
        countryPolandFormEchannel:{
          hsbcAdditionalUser:[],
          polandChannelAdmins:[],
          echannelAdminData:[]
        }
      },
      id:'',
      lid:'',
    };
  }
  loadPageState = () =>{
    var {caseId, productId} = this.props.match.params;
    eapiClient("/countryForms/case/" + caseId + "/product/" + productId)
    .then(({data}) => {
      if(data.responseData.countryPolandFormEchannel !== undefined){
        this.setState({
          methodFlag: true,
          countryPolandForm:data.responseData,
          dataReady :true
        });
      }
      else{
        this.setState({id:data.responseData.id, lid:data.responseData.lid,
          dataReady: true
        });
      }
    });
  }

  componentWillMount() {
    var {caseId} = this.props.match.params;
    loadIfStateAvailableInSessionStorage(this, null, () => {
      this.loadPageState();
    });
    let apiURL ="/aemData/formData/json_create-cash-oncentration-responsible-officer-details";
    if (this.props.mode === "edit") {
      apiURL = apiURL.replace("json_create-", "json_edit-");
    }
    aemHostClient(apiURL)
    .then(({data}) => {
      this.setState({ formJson : data.guideContainer});
    });

    eapiClient("/persons/case/" + caseId)
    .then(({data}) => {
      this.props.setPersons(data.responseData);
    });

    // eapiClient("/countryForms/case/" + caseId + "/echanneladmins")
    // .then(({data}) => {
    //   this.setState({ echannelAdminData : data.responseData });
    // });

  }

  translations = (text) => {
    return Translations(text,this.props.lang.currentLang.lang, this.props.lang.translatedData)
  }

  translateWord = (word) => {
    var currentWord = Translations(word,this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForRadio(currentWord);
    return convertedArray;
  }

  componentDidMount(){
    var getCurrentDropDown = window.sessionStorage.getItem("getCurrentDropDown");
    var getCurrentDropDownValue = window.sessionStorage.getItem('key'+ getCurrentDropDown);

    if(getCurrentDropDown !== null){
      var getCurrentDropDownName =  getCurrentDropDown.substring(0,getCurrentDropDown.length -1);
    }
    if(getCurrentDropDownName ==='hsbcAdditionalUser'){
      var getCurrentDropDownIndex = getCurrentDropDown.substring(getCurrentDropDown.length -1);
    }

    if(getCurrentDropDownName === 'hsbcAdditionalUser'){
      if(this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser.length ===0 && getCurrentDropDownValue !== null){
        var _hsbcAdditionalUser = [...this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser];
        _hsbcAdditionalUser[0] = {signatoryId:getCurrentDropDownValue, polResident : false};
        this.setState({countryPolandForm: {
          countryPolandFormEchannel :{...this.state.countryPolandForm.countryPolandFormEchannel, hsbcAdditionalUser:_hsbcAdditionalUser
          }}});


        }
        this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser.forEach((currentValue, index, arr) =>{
          if(currentValue!==getCurrentDropDownValue && index===getCurrentDropDownIndex-1 && getCurrentDropDownValue !== null){
            var _hsbcAdditionalUser = [...this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser];
            _hsbcAdditionalUser[index] = {signatoryId:getCurrentDropDownValue, polResident : false};
            this.setState({countryPolandForm: {
              countryPolandFormEchannel :{...this.state.countryPolandForm.countryPolandFormEchannel, hsbcAdditionalUser:_hsbcAdditionalUser
              }}});


            }else if(getCurrentDropDownValue !== null && index!==getCurrentDropDownIndex-1 && getCurrentDropDownName === 'hsbcAdditionalUser') {
              var _hsbcAdditionalUser1 = [...this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser];
              _hsbcAdditionalUser1[getCurrentDropDownIndex-1] = {signatoryId:getCurrentDropDownValue, polResident : false};
              this.setState({countryPolandForm: {
                countryPolandFormEchannel :{...this.state.countryPolandForm.countryPolandFormEchannel, hsbcAdditionalUser:_hsbcAdditionalUser1
                }}});

              }
            })
          }

          window.sessionStorage.removeItem("getCurrentDropDown");
          window.sessionStorage.removeItem('key'+ getCurrentDropDown);
        }

        saveStateToSessionOnEdit = () => {
          savePageStateInSessionStorage(this.state, this.props.history.location.pathname);
        }

        saveForm =() =>{
          let apiURL;
          let payLoad={};
          let countryPolandFormEchannel ={};
          var {caseId, productId} = this.props.match.params;
          apiURL = "/countryForms/case/" + caseId + "/product/" + productId;
          payLoad.caseId = caseId;
          payLoad.productId=productId;
          payLoad.id=this.state.id;
          payLoad.lid=this.state.lid;
          countryPolandFormEchannel.hsbcAdditionalUser = this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser;
          countryPolandFormEchannel.polandChannelAdmins = this.state.countryPolandForm.countryPolandFormEchannel.polandChannelAdmins;
          countryPolandFormEchannel.addAdditionalHSBCAdmin = this.state.countryPolandForm.countryPolandFormEchannel.addAdditionalHSBCAdmin;
          payLoad.countryFormName = "Poland hsbcnet User Notification"
          payLoad.countryPolandFormEchannel = countryPolandFormEchannel;

          if(payLoad.countryPolandFormEchannel.polandChannelAdmins.length === 0 && this.state.echannelAdminData[0] !== undefined){
            let channelAdminObj={}
            channelAdminObj.channelAdminId = this.state.echannelAdminData[0].id;

            payLoad.countryPolandFormEchannel.polandChannelAdmins.push(channelAdminObj);
          }
          eapiClient(apiURL,{
            method:"PUT",
            data: JSON.stringify(payLoad)
          })

          .then(({data}) => {
          });
          this.props.history.goBack();
        }

        onFormSubmit = (event, apiURL) => {

        }

        onFormCancel = () => {
          this.props.history.goBack();
        }

        setAdministratorfields = (index, type, event) =>{

          let _hsbcAdditionalUser = [...this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser];
          if(_hsbcAdditionalUser[index] === undefined) {
            _hsbcAdditionalUser[index] = {};
          }

          if(type === "polResidentIdNumber"){
            _hsbcAdditionalUser[index][event.target.name] = event.target.value;
          }

          if(type === "polIdDocNumber"){
            _hsbcAdditionalUser[index][event.target.name] = event.target.value;
          }
          this.setState({countryPolandForm:{countryPolandFormEchannel: {...this.state.countryPolandForm.countryPolandFormEchannel, hsbcAdditionalUser:_hsbcAdditionalUser}}});
        }

        setAdministratorDatefields =(index, type, value, name) =>{

          let _hsbcAdditionalUser = [...this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser];
          if(_hsbcAdditionalUser[index] === undefined) {
            _hsbcAdditionalUser[index] = {};
          }
          if(type === "dateOfBirth"){
            _hsbcAdditionalUser[index]['dateOfBirth'] = value;
          }

          if(type === "docIssueDate"){
            _hsbcAdditionalUser[index]['docIssueDate'] = value;
          }

          if(type === "docExpiryDate"){
            _hsbcAdditionalUser[index]['docExpiryDate'] = value;
          }
          if(type === "polResident"){
            _hsbcAdditionalUser[index]['polResident'] = value;
          }

          if(type === "systemAdminPrivileges"){
            _hsbcAdditionalUser[index]['systemAdminPrivileges'] = value;
          }

          this.setState({countryPolandForm: {countryPolandFormEchannel :{...this.state.countryPolandForm.countryPolandFormEchannel, hsbcAdditionalUser:_hsbcAdditionalUser}}});
        }


        handleSystemAdminEditClick = (accountSignatory) => {
          var {caseId} = this.props.match.params;
          if(accountSignatory) {
            this.saveStateToSessionOnEdit();
            this.props.history.push("/case-body/country-forms/create-user/" + accountSignatory.id + '/' + caseId);
          }
        }
        handleAdministratorfieldsChange = (index, hsbcAdditionalUser) => {
          let _hsbcAdditionalUser = [...this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser];
          _hsbcAdditionalUser[index] = {signatoryId: hsbcAdditionalUser.id, polResident : false};
          this.setState({countryPolandForm: {
            countryPolandFormEchannel :{...this.state.countryPolandForm.countryPolandFormEchannel, hsbcAdditionalUser:_hsbcAdditionalUser
            }}});

          }
          /* Code fo Date Selector*/
          action(name) {
            return name;
          }

          logAction(name) {
            return this.action;
          }

          render() {

            var {caseId} = this.props.match.params;

            return (
              this.state.formJson !== undefined ?
              <div className="form-container">
              <div className="gdocs-poland-country-form-container">
              <div>
              <h3 className="form-heading">{this.translations(this.state.formJson.rootPanel.items.guidetextbox_mainTitle.pageHeading)}</h3>
              <div className="gdocs-clear-float"></div>
              <p className="form-required-desc optional-text">{this.state.formJson ? this.translations(this.state.formJson.rootPanel.items.guidetextbox_mainTitle.descriptionText) : ''}</p>
              </div>
              <div className="gdocs-clear-float"></div>
              <div className="gdocs-poland-user-form">
              <div className="gdocs-poland-user-wrapper">
              <div className="gdocs-poland-user-position">{this.translations(this.state.formJson.rootPanel.items.guideMultiDropdownlist_resOfficer.createText)}</div>
              <div className="gdocs-poland-user-position">
              <MultiLineSelect defaultValue="Please select"
              requiredFields={{
                "row1": ["firstName", "lastName"],
                "row2": ["dateOfBirth", "countryOfResidence", "nationality"],
                "row3": []
              }}
              requiredFieldsPrefixes={{
                "row1": ["", "", "", ""],
                "row2": [""],
                "row3": ["Tel", "Fax"]
              }}
              data={[]}

              value={this.state.countryPolandForm.countryPolandFormEchannel && this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser !== undefined ?
                this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser.signatoryId : ''}
                onEdit={this.handleSystemAdminEditClick}  _onChange={this.handleAdministratorfieldsChange.bind(this, )}
                />
                <span className="icon icon-add addicon"></span>
                <PersistLink className="mrg-left"
                history={this.props.history}
                state={this.state}
                to={'/case-body/country-forms/create-user/' + caseId}
                data={`hsbcAdditionalUser`}>
                Create new user
                </PersistLink>

                </div>
                </div>
                <div className="gdocs-poland-user-wrapper">
                <div className="gdocs-poland-user-position">{this.translations(this.state.formJson.rootPanel.items.guideMultiDropdownlist_address.title)}</div>
                <div className="gdocs-poland-user-position">
                  <SingleLineSelect
                  requiredFields={["firstName", "lastName", "jobTitle"]}
                  optionsData={this.props.persons || []}
                  disabledOptions={this.state.countryPolandForm.countryPolandFormEchannel.taxDeclarationSignatories}
                  _value={this.state.countryPolandForm.countryPolandFormEchannel.taxDeclarationSignatories!== undefined ? this.state.countryPolandForm.countryPolandFormEchannel.taxDeclarationSignatories : ''}
                  onEdit={this.handleDeclarationSignatoryEditClick} _onChange={this.handleDeclarationSignatoriesChange} />

                  <span className="icon icon-add addicon"></span>
                  <PersistLink className="mrg-left"
                  history={this.props.history}
                  state={this.state}
                  to={'/case-body/country-forms/create-signatory/' + caseId + '/'}
                  data={`Addess`}>
                  {this.translations(this.state.formJson.rootPanel.items.guideMultiDropdownlist_address.createText)}
                  </PersistLink>

                </div>
                </div>

                <div className="gdocs-poland-user-wrapper">
                <div className="gdocs-poland-user-position gdocs-admin-privilege-lbl">{this.translations(this.state.formJson.rootPanel.items.guideradiobutton_polishResident.title)}</div>
                <div className="gdocs-poland-user-position">
                <label className="gdocs-poland-user-lbl">{this.translateWord(this.state.formJson.rootPanel.items.guideradiobutton_polishResident.options)[0].split('=')[1]}
                <Radiobutton  _value={this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser && this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser.polResident ?
                  this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser.polResident : ''}

                  setInputvalue={this.setAdministratorDatefields.bind(this,"polResident")}
                  name={`polResident`} value="true"/>
                  </label>

                  <label className="gdocs-poland-user-lbl">{this.translateWord(this.state.formJson.rootPanel.items.guideradiobutton_polishResident.options)[1].split('=')[1]}
                  <Radiobutton _value={this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser && this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser.polResident  ?
                    this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser.polResident: false}
                    setInputvalue={this.setAdministratorDatefields.bind(this,"polResident")}
                    name={`polResident`} value="false"/>
                    </label>
                    </div>
                    </div>
                    <div className="gdocs-poland-user-wrapper">
                    <div className="gdocs-poland-user-position">{this.translations(this.state.formJson.rootPanel.items.guidetextbox_prNumber.title)}</div>
                    <div className="gdocs-poland-user-position">
                    <input
                    type="text"
                    maxLength="11"
                    value = { this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser !== undefined ?
                      this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser.polResidentIdNumber : ''}
                      name ="polResidentIdNumber"
                      onChange={this.setAdministratorfields.bind(this, "polResidentIdNumber")}
                      />
                      </div>
                      </div>
                      <div className="gdocs-poland-user-wrapper">
                      <div className="gdocs-poland-user-position">{this.translations(this.state.formJson.rootPanel.items.guidetextbox_idNumber.title)}</div>
                      <div className="gdocs-poland-user-position">
                      <input
                      type="text"
                      maxLength="18"
                      name="polIdDocNumber"
                      value = {this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser !== undefined ?
                        this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser.polIdDocNumber : '' }
                        onChange={this.setAdministratorfields.bind(this, "polIdDocNumber")}
                        />
                        </div>
                        </div>

                        <div className="gdocs-poland-user-wrapper">
                        <div className="gdocs-poland-user-position">{this.translations(this.state.formJson.rootPanel.items.guidedatepicker_issueDate.title)} </div>
                        <div className="gdocs-poland-user-position">
                        <DateSelector
                        inputTypeAttr="text"
                        inputPlaceholderAttr='Enter date'
                        onDateSelected={ this.logAction('onDateSelected') }
                        extendedPanel={true}
                        dateRangeOptions={ [] }
                        showIcon={true}
                        currentName={`docIssueDate`}
                        name={`docIssueDate`}
                        reSeat={this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser &&
                          this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser.docIssueDate === '' ? true : false}
                          value={this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser &&
                            this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser.docIssueDate !== '' ?
                            this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser.docIssueDate : ''}
                            setdatepicker={this.setAdministratorDatefields.bind(this,"docIssueDate")}
                            />
                            </div>
                            </div>

                            <div className="gdocs-poland-user-wrapper">
                            <div className="gdocs-poland-user-position">{this.translations(this.state.formJson.rootPanel.items.guidedatepicker_expireDate.title)} </div>
                            <div className="gdocs-poland-user-position">
                            <DateSelector
                            inputTypeAttr="text"
                            inputPlaceholderAttr='Enter date'
                            onDateSelected={ this.logAction('onDateSelected') }
                            extendedPanel={true}
                            dateRangeOptions={ [] }
                            showIcon={true}
                            pastName={`docExpiryDate`}
                            name={`docExpiryDate`}
                            value={this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser !== undefined ?
                              this.state.countryPolandForm.countryPolandFormEchannel.hsbcAdditionalUser.docExpiryDate : ''}
                              setdatepicker={this.setAdministratorDatefields.bind(this,"docExpiryDate")}
                              />
                              </div>
                              </div>
                              </div>
                               <div key="buttons-wrapper" className="form-buttons-section save-btn-top-border">
                              <div className="form-buttons-wrapper">
                              <button onClick={this.saveForm} aria-label={this.translations(this.state.formJson.rootPanel.items.guidebutton_saveAndReturn.text)}
                                      className="gdocs-btn-submit">{this.translations(this.state.formJson.rootPanel.items.guidebutton_saveAndReturn.text)}
                              </button>
                              </div>
                              </div>
                              </div>
                              </div>


                            :'')
                          }
                        }

                          const mapStateToProps = state => {
                            return {
                              persons: state.persons,
                              lang:state.lang
                            }
                          }
                          const mapDispatchToProps = dispatch => {
                            return {
                              setPersons: persons => {
                                dispatch(setPersons(persons));
                              }
                            }
                          }
                          export default connect(mapStateToProps, mapDispatchToProps)(PolandHsbcNetUserForm);



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CountryForms/PolandCountryForm/index.js